import React, { useContext } from 'react';
import pt from 'prop-types';
import * as styles from './filterTag.module.scss';
import { combine } from '/src/helpers/styles';
import Text from '../text';
import Icon from '../icon';
import { MicrocopyContext } from '../../../context/microcopy.context';
import { getCopy } from '../../../helpers/copy';
import { useLocale } from '../../../context/locale.context';
import { getCountryName } from '../../../utils/constants';

const FilterTag = ({
  text,
  removeLink,
  isGolden,
  isLocked,
  className,
  filterKey,
  filterId,
  type,
  year,
  ...props
}) => {
  const microcopy = useContext(MicrocopyContext);
  const { locale } = useLocale();

  const getLabel = () => {
    if (
      filterKey &&
      ((typeof filterId === 'string' && filterId.length) ||
        typeof filterId === 'number')
    ) {
      if (filterKey === 'yearId') {
        return getCopy(
          `filters.time.${filterId}${type !== '' ? `.${type}` : ''}`,
          microcopy
        ).replace('%YEAR%', year - filterId);
      }

      if (filterKey === 'profileTypeId') {
        return getCopy(
          `filters.profiletypes.${filterId}${type !== '' ? `.${type}` : ''}`,
          microcopy
        );
      }

      if (filterKey === 'regionId') {
        return getCopy(
          `filters.region.${filterId.replaceAll(' ', '').toLowerCase()}`,
          microcopy
        );
      }

      if (filterKey === 'countryId') {
        return getCountryName(locale, filterId);
      }

      if (filterKey === 'awardId') {
        let key = filterId;
        if (key === 9999) {
          key = '2.special';
        } else if (key === 7777) {
          key = '1.special';
        }
        return getCopy(`filters.awards.${key}`, microcopy);
      }
    }
    return getCopy(text, microcopy);
  };

  return (
    <span
      className={combine(
        styles.filterTag,
        isGolden && styles.gold,
        isLocked && styles.locked,
        className
      )}
    >
      <a href={removeLink} className={styles.button} {...props}>
        <Icon name="times" className={styles.icon} />
        <Text as="span" type="metanavi">
          {getLabel()}
        </Text>
      </a>
    </span>
  );
};

FilterTag.propTypes = {
  text: pt.string.isRequired,
  removeLink: pt.string,
  isGolden: pt.bool,
  isLocked: pt.bool,
  className: pt.string,
  filterKey: pt.string,
  filterId: pt.oneOfType([pt.string, pt.number]),
};

FilterTag.defaultProps = {
  isGolden: false,
  isLocked: false,
  className: '',
  filterKey: '',
  filterId: '',
};

export default FilterTag;
